import { AHIcon, AHIconType } from "./AHIcon";
import { ColorType } from "./AHTheme/AHTheme";
import { createContext } from "react";
import { BaseButton } from "./BaseButton";

export type FilterButtonMode = "inactive" | "active";

const DialogButtonTextColorCtx = createContext<ColorType>("text-primary");

export function FilterButton(
  props: {
    children: React.ReactNode;
    indicatorIcon?: AHIconType;
    indicatorComponent?: React.ReactNode;

    onPress?: () => void;
    disablePadding?: boolean;
    indicatorSize?: number; // used for padding purposes
  } & (
    | {
        mode: "inactive";
      }
    | {
        mode: "active";
        isPlural: boolean;
      }
  )
) {
  const mode = props.mode;

  const textColor: ColorType =
    mode === "active" ? "text-inverted" : "text-secondary";

  const background: ColorType = mode === "active" ? "darkerText" : "background";

  return (
    <BaseButton
      borderColor={background}
      background={background}
      onPress={props.onPress}
      indicatorSize={props.indicatorSize}
    >
      {props.indicatorIcon ? (
        <AHIcon type={props.indicatorIcon} size="xsmall" color={textColor} />
      ) : (
        props.indicatorComponent
      )}
      <DialogButtonTextColorCtx.Provider value={textColor}>
        <BaseButton.Label color={textColor}>{props.children}</BaseButton.Label>
      </DialogButtonTextColorCtx.Provider>
      {props.mode === "active" ? (
        <AHIcon
          type={props.isPlural ? "chevron-down" : "clear"}
          size="xsmall"
          color={textColor}
        />
      ) : null}
    </BaseButton>
  );
}
